/* eslint-disable no-lone-blocks */
import React from 'react';
import PropTypes from 'prop-types';
import { map, orderBy } from 'lodash';
import AudienceAgeChart from './charts/AudienceAgeChart';
import AudienceGenderChart from './charts/AudienceGenderChart';
import EngagementRateChart from './charts/EngagementRateChart';
import AudienceEthnicityChart from './charts/AudienceEthnicityChart';
import { nFormatter, GRAPH_CONST_VALUES } from '../../../utils';

function DemoGraphView(props) {
  const {
    graphData,
    graphData: {
      followers: {
        facebook, instagram, youtube, spotify, twitter,
      },
    },
    categoriesData,
  } = props;

  const updatedCountryArr = [];
  const updatedStateArr = [];
  const renderTopCountry = (dataArr) => {
    let returnValue = null;
    Object.entries(dataArr).forEach(([key, value]) => {
      switch (key) {
        case GRAPH_CONST_VALUES.COUNTRY_ONE:
          updatedCountryArr.push({ country: value, followers: dataArr.countryFollowers1 });
          break;
        case GRAPH_CONST_VALUES.COUNTRY_TWO:
          updatedCountryArr.push({ country: value, followers: dataArr.countryFollowers2 });
          break;
        case GRAPH_CONST_VALUES.COUNTRY_THREE:
          updatedCountryArr.push({ country: value, followers: dataArr.countryFollowers3 });
          break;
        default:
          break;
      }
    });
    const arrForRenderHtml = orderBy(updatedCountryArr, ['followers'], ['desc']);
    if (arrForRenderHtml.length > 0) {
      returnValue = map(arrForRenderHtml, (item) => item.followers > 0 && item.country && item.country.label !== null && (
        <div className="graph-box-content-count" key={`${item.followers}-${item.country.label}`}>
          <h3>
            {item.followers}
            %
          </h3>
          <span>{item.country.label}</span>
        </div>
      ));
    }
    return returnValue;
  };

  const renderTopStates = (dataArr) => {
    let returnValue = null;
    Object.entries(dataArr).forEach(([key, value]) => {
      switch (key) {
        case GRAPH_CONST_VALUES.STATE_ONE:
          updatedStateArr.push({ state: value, country: dataArr.stateCountry1, followers: dataArr.stateFollowers1 });
          break;
        case GRAPH_CONST_VALUES.STATE_TWO:
          updatedStateArr.push({ state: value, country: dataArr.stateCountry2, followers: dataArr.stateFollowers2 });
          break;
        case GRAPH_CONST_VALUES.STATE_THREE:
          updatedStateArr.push({ state: value, country: dataArr.stateCountry3, followers: dataArr.stateFollowers3 });
          break;
        case GRAPH_CONST_VALUES.STATE_FOUR:
          updatedStateArr.push({ state: value, country: dataArr.stateCountry4, followers: dataArr.stateFollowers4 });
          break;
        case GRAPH_CONST_VALUES.STATE_FIVE:
          updatedStateArr.push({ state: value, country: dataArr.stateCountry5, followers: dataArr.stateFollowers5 });
          break;
        default:
          break;
      }
    });
    const arrForRenderHtml = orderBy(updatedStateArr, ['followers'], ['desc']);
    if (arrForRenderHtml.length > 0) {
      returnValue = map(arrForRenderHtml, (item) => item.followers > 0
      && (item.state && item.state.label !== null) && (
        <div className="graph-box-content-count" key={`${item.followers}-${item.state.label}`}>
          <h3>
            {item.followers}
            %
          </h3>
          <span>{item.state.label}</span>
        </div>
      ));
    }
    return returnValue;
  };

  const renderSubCategories = (subCategory) => map(subCategory, (subEle) => subEle && (
    <>
      <span className="graph-tag-column" key={Math.random()}>{subEle.name}</span>
    </>
  ));

  const renderCategories = () => map(categoriesData, (item, index) => item && (
    <>
      <span className="graph-tag-column" key={`categories-${index}`}>{item.name}</span>
      {(item.subCategory && item.subCategory.length > 0) && renderSubCategories(item.subCategory)}
    </>
  ));

  return (
    <>
      <div className="graph">
        <div className="graph-wrapper">
          <div className="graph-audience">
            <div className="graph-box">
              <h2>Audience Age group</h2>
              <AudienceAgeChart audienceGraphData={graphData.audienceAge} />
            </div>
            <div className="graph-box graph-70">
              <h2>
                Followers
                <span>
                  {graphData.authenticFollowers}
                  % Authentic
                </span>
              </h2>
              <div className="graph-box-content count-5">
                <div className="graph-box-content-count">
                  <h4>{nFormatter(facebook)}</h4>
                  <em className="facebook" />
                </div>
                <div className="graph-box-content-count">
                  <h4>{nFormatter(instagram)}</h4>
                  <em className="instagram" />
                </div>
                <div className="graph-box-content-count">
                  <h4>{nFormatter(youtube)}</h4>
                  <em className="youtube" />
                </div>
                <div className="graph-box-content-count">
                  <h4>{nFormatter(spotify)}</h4>
                  <em className="spotify" />
                </div>
                <div className="graph-box-content-count">
                  <h4>{nFormatter(twitter)}</h4>
                  <em className="twitter" />
                </div>
              </div>
            </div>
            <div className="graph-box graph-30">
              <h2>Audience Gender</h2>
              <AudienceGenderChart graphData={graphData.audienceGender} />
            </div>
            <div className="graph-box">
              <h2>Top countries</h2>
              <div className="graph-box-content count-5">
                {renderTopCountry(graphData.topCountry)}
              </div>
            </div>
            <div className="graph-box">
              <h2>Top states</h2>
              <div className="graph-box-content count-5">
                {renderTopStates(graphData.topState)}
              </div>
            </div>
          </div>
          <div className="graph-category">
            <div className="graph-box engagement engagement-rate pb-0">
              <h2>Engagement Rate</h2>
              {graphData.engagementRate && (
                <ul>
                  <li className="facebook" />
                  <li className="instagram" />
                  <li className="twitter" />
                </ul>
              )}
              <EngagementRateChart engagementGraphData={graphData.engagementRate} />
            </div>
            <div className="graph-box engagement">
              <h2>Audience Ethnicity</h2>
              <AudienceEthnicityChart ethnicityGraphData={graphData.audienceEthnicity} />
            </div>
            {
              categoriesData && categoriesData.length > 0
            && (
            <div className="graph-tag">
              <h2>Brands/Categories of interest</h2>
              <div className="graph-tag-row">
                {renderCategories()}
              </div>
            </div>
            )
            }
          </div>
        </div>
      </div>
    </>
  );
}

DemoGraphView.propTypes = {
  graphData: PropTypes.object.isRequired,
  categoriesData: PropTypes.array,
};

DemoGraphView.defaultProps = {
  categoriesData: [],
};

export default DemoGraphView;
